
  <datatable-body-row
    *ngIf="summaryRow && _internalColumns"
    tabindex="-1"
    [innerWidth]="innerWidth"
    [offsetX]="offsetX"
    [columns]="_internalColumns"
    [rowHeight]="rowHeight"
    [row]="summaryRow"
    [rowIndex]="-1">
  </datatable-body-row>
  


// WEBPACK FOOTER //
// ./node_modules/@swimlane/ngx-datatable/release/components/body/summary/summary-row.component.d.ts.DataTableSummaryRowComponent.html